import React from "react";
import { fetchSectionAuditLogs } from "../../../services/dashboardServices";
import WithAuditLogs from "./WithAuditLogs";

const SectionAuditLogs = ({ sectionId, sectionTitle, onClose }) => (
  <WithAuditLogs
    id={sectionId}
    title={`Audit Logs for section: ${sectionTitle}`}
    fetchFn={fetchSectionAuditLogs}
    onClose={onClose}
  />
);

export default SectionAuditLogs;
